module.exports = __webpack_public_path__ + "static/media/three_quarters_right_back_picture.4bf725e6.jpg";